(() => {
    const config = { attributes: true, childList: true, subtree: true };

    const callback = () => {
        const ltspMessages = document.querySelectorAll('.bss-lock-element a');
        ltspMessages.forEach(message => {
            if (message.href?.includes("checkout_url")) {
                message.href = message.href.replaceAll('checkout_url', 'return_to')
            }
        });
    };
    
    const observer = new MutationObserver(callback);
    
    observer.observe(document.body, config);
})();
